export const translations = {
  en: {
    'nav.home': 'Home',
    'nav.m1pro': 'M1 Pro',
    'nav.systems': 'Lighting Systems',
    'nav.mount': 'Magnetic Mount System',
    'nav.engineering': 'Engineering',
    'nav.applications': 'Applications',
    'nav.support': 'Support',
    'nav.shop': 'Shop Now',
    'nav.lighting': 'Lighting',
    'nav.magnetic': 'Magnetic',
    'nav.menu': 'Menu',
    'hero.brand': 'Professional-Grade Lighting. Built for the Elements.',
    'hero.headline': 'Same Water. A Brighter World.',
    'hero.support': 'Transform your pool and outdoor spaces with the MarineForceLED M1 Pro Wireless Lighting System.',
    'hero.shopNow': 'Shop Now',
    'common.from': 'From',
    'offer.fromPerLight': 'Build your M1 PRO system from',
    'offer.extras': 'Exclusive pricing on extra lights with every system',
    'offer.warrantyOn': 'on 4+ light systems',
    'nav.track': 'Track Order',
    'shop.tabSystems': 'Complete Systems',
    'shop.tabByo': 'Build Your Own',
    'shop.notSure': 'Not sure how many? Find your system',
    'trust.secure': 'Secure checkout by',
    'sticky.label': 'M1 PRO Lighting Systems',
    'proto.bar': 'Prototype preview — prices, specifications and warranty terms are pending owner approval.',
    'hero.h1': 'Professional-Grade Lighting.',
    'hero.h2': 'Built for the Elements.',
    'hero.sub':
      'Transform your pool with the M1 PRO Wireless RGB Lighting System. Professional marine-inspired design. No wires. No drilling. No complicated installation.',
    'hero.cta1': 'Build Your Lighting System',
    'hero.cta2': 'Explore M1 Pro',
    'common.addToCart': 'Add to Cart',
    'common.perLight': 'per light',
    'common.save': 'Save',
    'common.total': 'Total',
    'common.qty': 'Quantity',
    'common.lights': 'lights',
    'common.light': 'light',
    'common.shipping': 'Shipping calculated at checkout',
    'common.pending': 'Pending approval',
    'paths.byo': 'Build Your Own System',
    'paths.systems': 'Complete Lighting Systems',
    'byo.headline': 'Your Space. Your Rules.',
    'systems.headline': 'Complete Systems. Professional Results.',
    'systems.cta': 'Choose This System',
    'upsell.headline': 'Your Bundle Unlocks More.',
    'upsell.sub': 'Add extra M1 PRO lights at exclusive bundle pricing.',
    'upsell.accept': 'Add Extra Lights to My System',
    'upsell.decline': 'No Thanks, Keep My System',
    'rec.headline': 'Find Your Perfect Lighting System.',
    'rec.question': 'What are you lighting?',
    'cart.title': 'Your Lighting System',
    'cart.empty': 'Your cart is empty.',
    'cart.checkout': 'Continue to Secure Checkout',
    'cart.subtotal': 'Subtotal',
    'footer.tagline': 'Engineered for a Brighter Tomorrow.',
  },
  es: {
    'nav.home': 'Inicio',
    'nav.m1pro': 'M1 Pro',
    'nav.systems': 'Sistemas de Iluminación',
    'nav.mount': 'Magnetic Mount System',
    'nav.engineering': 'Ingeniería',
    'nav.applications': 'Aplicaciones',
    'nav.support': 'Soporte',
    'nav.shop': 'Comprar',
    'nav.lighting': 'Iluminación',
    'nav.magnetic': 'Magnético',
    'nav.menu': 'Menú',
    'hero.brand': 'Iluminación de grado profesional. Hecha para los elementos.',
    'hero.headline': 'Misma agua. Un mundo más brillante.',
    'hero.support': 'Transforma tu piscina y tus espacios exteriores con el Sistema de Iluminación Inalámbrica M1 Pro de MarineForceLED.',
    'hero.shopNow': 'Comprar ahora',
    'common.from': 'Desde',
    'offer.fromPerLight': 'Arma tu sistema M1 PRO desde',
    'offer.extras': 'Precio exclusivo en luces extra con cada sistema',
    'offer.warrantyOn': 'en sistemas de 4+ luces',
    'nav.track': 'Rastrear pedido',
    'shop.tabSystems': 'Sistemas completos',
    'shop.tabByo': 'Arma el tuyo',
    'shop.notSure': '¿No sabes cuántas? Encuentra tu sistema',
    'trust.secure': 'Pago seguro con',
    'sticky.label': 'Sistemas de iluminación M1 PRO',
    'proto.bar': 'Vista previa — precios, especificaciones y garantías pendientes de aprobación.',
    'hero.h1': 'Iluminación de Grado Profesional.',
    'hero.h2': 'Hecha para los Elementos.',
    'hero.sub':
      'Transforma tu piscina con el Sistema de Iluminación Inalámbrica RGB M1 PRO. Diseño profesional de inspiración marina. Sin cables. Sin perforaciones. Sin instalación complicada.',
    'hero.cta1': 'Arma tu Sistema',
    'hero.cta2': 'Explora M1 Pro',
    'common.addToCart': 'Agregar al carrito',
    'common.perLight': 'por luz',
    'common.save': 'Ahorra',
    'common.total': 'Total',
    'common.qty': 'Cantidad',
    'common.lights': 'luces',
    'common.light': 'luz',
    'common.shipping': 'Envío calculado al pagar',
    'common.pending': 'Pendiente de aprobación',
    'paths.byo': 'Arma tu Propio Sistema',
    'paths.systems': 'Sistemas Completos',
    'byo.headline': 'Tu Espacio. Tus Reglas.',
    'systems.headline': 'Sistemas Completos. Resultados Profesionales.',
    'systems.cta': 'Elegir este sistema',
    'upsell.headline': 'Tu Paquete Desbloquea Más.',
    'upsell.sub': 'Agrega luces M1 PRO adicionales a precio exclusivo de paquete.',
    'upsell.accept': 'Agregar luces extra a mi sistema',
    'upsell.decline': 'No, gracias. Mantener mi sistema',
    'rec.headline': 'Encuentra tu Sistema Ideal.',
    'rec.question': '¿Qué vas a iluminar?',
    'cart.title': 'Tu Sistema de Iluminación',
    'cart.empty': 'Tu carrito está vacío.',
    'cart.checkout': 'Continuar al pago seguro',
    'cart.subtotal': 'Subtotal',
    'footer.tagline': 'Diseñado para un mañana más brillante.',
  },
} as const;

export type TranslationKey = keyof (typeof translations)['en'];
